import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject, ViewChild, OnChanges } from '@angular/core';
import {
  CheckInterviewSchDataObj,
  ServiceLine,
  DataIds,
  ITemplate,
  InterviewActivity,
  ISnackbarData,
  CorrespondenceDataObj,
  Venue,
  Template,
  ISaveInterviewActivity,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FileService } from '../../../core/services/file.service';
import { ActivityCorrespondenceComponent } from '../activity-correspondence/activity-correspondence.component';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { SchedulerCandidate } from '../../../shared/models/schedulerAssociate';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-coupled-schduele-interview-activity',
  templateUrl: './coupled-schduele-interview-activity.component.html',
  styleUrls: ['./coupled-schduele-interview-activity.component.scss'],
  standalone: false,
})
export class CoupledSchdueleInterviewActivityComponent implements OnInit, OnChanges {
  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  toggleBtn: boolean = false;
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;
  snackbarData: ISnackbarData;

  sendMailCheck: boolean = false;
  mailFlag: boolean = false;
  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();

  @ViewChild(ActivityCorrespondenceComponent) corresActivity: ActivityCorrespondenceComponent;

  // @Input() interviewSIActivityNames:string[];
  inputVal: string;
  inputValRemarks: string;
  ids: DataIds;
  notes: string;
  startDate: string;
  endDate: string;
  startTime: number;
  endTime: number;
  //VenueId: number;
  deleteMsg: string;
  saveMsg: string;
  start: string;
  end: string;
  @Input() candidateApplicationIds: number[];
  editactivity: any = false;
  templateData: ITemplate[];
  InterviewTemplateData: ITemplate[];
  templateObj: ITemplate;
  userloggedin: any;
  loginUserName: any;

  addEvent1(event: MatDatepickerInputEvent<Date>) {
    this.startDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    console.log(this.startDate);
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.endDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    console.log(this.endDate);
  }
  select(startTime) {
    console.log('starttime selected', startTime);
    // console.log(typeof startTime);
    // let timestring= startTime[0] + startTime[1] + startTime[3] + startTime[4];
    this.startTime = +(startTime[0] + startTime[1] + startTime[3] + startTime[4]);
    // console.log(typeof this.startTime, this.startTime);
    // this.startTime=Number(timestring);
    console.log(typeof this.startTime, this.startTime);
  }
  // select1(endTime) {
  //   this.endTime = +(endTime.slice(0, 2) + endTime.slice(3));
  //   console.log(this.endTime);

  // }

  @Input() checkInterviewSchDataObj: CheckInterviewSchDataObj;
  @Input() ifCoupled: boolean;
  @Input() candidateEmails: string[];

  serviceLine: ServiceLine[];

  venue: Venue[];
  selectedVenue: Venue;

  templates: Template[];

  isDeleteDisable: boolean = true;

  correspondenceDataObj: CorrespondenceDataObj;
  @Input() interviewFlag: boolean;
  selectedTemplate: any;
  selectedClauseIndex: any;
  @Input() selectedCandidate: SchedulerCandidate[];
  VenueId: any;
  @Output() coupledformValid: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private interviewService: ActivityService,
    private datePipe: DatePipe,
    private fileService: FileService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkInterviewSchDataObj = data.checkInterviewSchDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }
  ngOnChanges() {
    this.notes = '';
    this.startDate = '';
    this.endDate = '';

    this.startTime = null;
    this.endTime = null;

    this.selectedVenue = null;
    this.selectedTemplate = -1;
  }
  testformValid(flag) {
    console.log('couple form valid');
    this.coupledformValid.emit(flag);
  }
  ngOnInit() {
    //this.getActivity();
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

    console.log(this.interviewFlag);
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    this.notes = '';
    this.startDate = '';
    this.endDate = '';

    this.startTime = null;
    this.endTime = null;

    this.selectedVenue = null;
    this.selectedTemplate = -1;
    // this.editId = { objectId: this.checkInterviewSchDataObj.applicationId, objectType: 'AP' };

    // this.interviewService.getServiceLine().subscribe(data => {
    //   console.log(data);
    //   this.serviceLine = data;
    //   console.log(this.serviceLine);
    // })

    this.correspondenceDataObj = {
      isVisible: true,
      candidateName: this.checkInterviewSchDataObj.candidateName,
      activityName: this.checkInterviewSchDataObj.activityName, //hardcode
      applicationId: this.checkInterviewSchDataObj.applicationId,
      processId: this.checkInterviewSchDataObj.processId,
      activityId: this.checkInterviewSchDataObj.activityId, //hardcode
      // statusId: this.checkInterviewSchDataObj.statusId //hardcode
    };

    //this.dataInitialization(this.checkInterviewSchDataObj.interviewActivity);
    this.interviewService.getVenue().subscribe((data) => {
      this.venue = data;
      console.log(data);
      console.log(this.venue);
    });
    if (
      this.checkInterviewSchDataObj &&
      this.checkInterviewSchDataObj.activityId &&
      this.checkInterviewSchDataObj.processId
    ) {
      this.interviewService
        .getTemplate(this.checkInterviewSchDataObj.activityId, this.checkInterviewSchDataObj.processId)
        .subscribe((data) => {
          // this.templates=data
          this.templateData = data;
          this.templateData = data;
          console.log(data);
        });
    }

    if (this.editactivity) {
      this.editId = {
        objectId: this.checkInterviewSchDataObj.applicationId,
        objectType: 'AP',
        activityivityId: this.checkInterviewSchDataObj.activityId,
      };

      this.getActivity(this.checkInterviewSchDataObj);
    }
  }
  getTemplateData(event) {
    console.log(event);
    const index = this.templateData.findIndex((item) => item.clauseid === event.value);
    console.log(index);
    this.selectedClauseIndex = index;
  }

  sendMailEnable() {
    console.log(this.sendMailCheck);
    // this.sendMailCheck = !this.sendMailCheck;
  }
  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  // Mock function to get data from input field.
  send() {
    console.log(this.startDate);
    this.ids = this.interviewService.getDataIds();
    if (this.editactivity) {
      const obj: InterviewActivity = {
        applicationIds: this.checkInterviewSchDataObj.applicationId,
        processID: this.checkInterviewSchDataObj.processId,
        activityID: this.checkInterviewSchDataObj.activityId,
        notes: this.notes,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.startTime,
        endTime: this.endTime,
        // statusId: this.checkInterviewSchDataObj.statusId,
        venueId: this.selectedVenue.venueId,
        clauseId: this.selectedTemplate,
        createdOn: this.checkInterviewSchDataObj.createdOn,
        createdBy: this.checkInterviewSchDataObj.createdBy,
      };
      this.editInterviewActivity(obj);
    } else {
      console.log(this.selectedVenue.venueId);
      const objS: ISaveInterviewActivity = {
        applicationIds: this.candidateApplicationIds,
        processID: this.checkInterviewSchDataObj.processId,
        activityID: this.checkInterviewSchDataObj.activityId,
        notes: this.notes,
        startDate: this.startDate,
        endDate: this.startDate,
        startTime: this.startTime,
        endTime: this.endTime,
        venueId: this.selectedVenue.venueId,
        // statusId: this.checkInterviewSchDataObj.statusId,
        clauseId: this.selectedTemplate,
      };
      console.log(objS);
      console.log(this.checkInterviewSchDataObj.interviewActivity);
      this.saveInterviewActivity(objS);
    }
    this.showMoreLess();
    // this.refreshcandiates.emit("true");
  }

  saveInterviewActivity(obj: ISaveInterviewActivity) {
    console.log('inside saveIntaCtivity');
    console.log(this.selectedTemplate);
    console.log(obj);
    let precheck;
    if (obj.startDate != '') {
      console.log('radhika');

      this.interviewService.saveInterviewActivity(obj).subscribe(
        (res: any) => {
          console.log(res);
          if (res.error && res.error.toLowerCase() === 'failure') {
            precheck = false;
            const data = {
              msg: res.message,
              isSuccess: 'error',
            };

            console.log(data);
            this.interviewService.openSnackBar(data, 'danger-snack');
          } else {
            // this.mailFlag = true;
            precheck = true;
            this.saveAttachment(this.checkInterviewSchDataObj.applicationId, this.companyHiringType);
            console.log('attachmnet called already');

            // this.refreshcandiates.emit("true");

            const data = {
              msg: res.message,
              isSuccess: 'created',
            };
            this.interviewService.openSnackBar(data, 'success-snack');
            this.refreshcandiates.emit('true');
          }
        },
        (err) => {
          console.log(err);
          const data = {
            msg: 'Some error occurred',
            isSuccess: false,
          };
          this.interviewService.openSnackBar(data, 'danger-snack');
        },
      );
      console.log('sendmailcheck-->', this.sendMailCheck, 'mailflag-->', this.mailFlag);
      if (this.sendMailCheck == true && precheck)
      // && this.mailFlag == true)
      {
        console.log('inside if');
        this.corresActivity.saveInterviewCorresActivity(
          this.correspondenceDataObj.processId,
          this.correspondenceDataObj.activityId,
          this.candidateApplicationIds,
        );
      }
    }
  }

  editInterviewActivity(editObj: InterviewActivity) {
    this.interviewService.editInterviewActivity(editObj).subscribe(
      (res: any) => {
        console.log('response' + res);
        this.saveAttachment(this.checkInterviewSchDataObj.applicationId, this.companyHiringType);
        // this.getActivity();
        const dataa = {
          msg: 'Data Updated Successfully !!! ',
          isSuccess: true,
        };

        this.interviewService.openSnackBar(dataa, 'success-snack');
      },
      (err) => {
        const data = {
          msg: err,
          isSuccess: false,
        };
        this.interviewService.openSnackBar(data, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getActivity(obj: CheckInterviewSchDataObj) {
    // obj.createdOn
    this.interviewService
      .getInterviewActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response) => {
        this.checkInterviewSchDataObj.interviewActivity = response;
        this.dataInitialization(response);
      });
  }

  dataInitialization(interviewactivityObj: any) {
    if (interviewactivityObj == null) {
      this.startDate = '';
      this.endDate = '';
      this.notes = '';
      this.isDeleteDisable = true;
    } else {
      this.notes = interviewactivityObj.notes;
      this.startDate = interviewactivityObj.startDate;
      this.startTime = interviewactivityObj.startTime;
      this.endDate = interviewactivityObj.endDate;
      this.VenueId = Number(interviewactivityObj.venue.venueID);
      this.selectedVenue = this.venue.find((v) => Number(v.venueId) === Number(this.VenueId));
      // time
      this.timeModifiedOn = interviewactivityObj.modifiedOn;
      this.isDeleteDisable = false;
      this.selectedTemplate = interviewactivityObj.clauseMasterlist.clauseId;
    }
  }

  deleteactivity() {}

  receiveFileOutput(filedata) {
    this.fileData = filedata['fileMerge1'];
    console.log(this.fileData);
    this.deletedFile = filedata['deletedFile1'];
  }

  saveAttachment(genericId, companyHiringTypeId) {
    console.log('save attachment');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {},
        );
      });
    }
    const activityId: any = this.checkInterviewSchDataObj.activityId;
    const formdata = new FormData();
    formdata.append('objectId', genericId);
    formdata.append('objectType', 'AP');
    formdata.append('attachmentId', '2');
    formdata.append('companyHiringTypeId', companyHiringTypeId);
    formdata.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        formdata.append('file[' + file.name + ']', file);
      });
      this.fileService.upload(formdata).subscribe(
        (_res) => {},
        (_err) => {
          const data = {
            msg: 'Some error Occurred',
            isSuccess: false,
          };
          this.interviewService.openSnackBar(data, 'danger-snack');
        },
      );
    }
  }
}
